import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaBdlogicDd.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        getText(map, node) {
            return `${this.name.slice(0, 4)}\n${this.name.slice(4)}`
        },

        _getCategories(map, node) {
            return [
                'BDLOGIC_INPUT',
                'BDLOGIC_OUTPUT',
                'BDLOGIC_TARGET',
            ]
        },
    })
}
